export const formatGqlErrors: (err) => Array<string> = (err) =>
  err.errors
    ? err.errors.map((error) => error.message)
    : err.message
    ? [err.message]
    : [err];
